import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { WebsiteContent } from "@/lib/website/content";

export function useWebsiteContent(path: string) {
  return useQuery({
    queryKey: ["website-content", path],
    queryFn: async () => {
      const { data, error } = await supabase.from("website_pages").select("published_content").eq("path", path).maybeSingle();
      if (error) throw error;
      return (data?.published_content ?? null) as unknown as WebsiteContent | null;
    },
    staleTime: 30000,
  });
}